import { Box, Grid, Stack, Typography, useTheme } from "@mui/material";

import { PendingWithdrawalsTable } from "Dashboard/Components/PendingWithdrawalsTable";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { ProjectStatusChart } from "Reporting/Components/ProjectStatusChart";
import { ReportingKpis } from "Reporting/Components/ReportingKpis";
import { UnstyledLink } from "Shared/Routing/UnstyledLink";

export const SysAdminDashboard = (): React.ReactNode => {
  const theme = useTheme();
  const { t } = useResource();

  return (
    <Stack spacing={Spacing.L}>
      <Box>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ marginBottom: theme.spacing(Spacing.M) }}
        >
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: 600,
              lineHeight: 1,
              color: theme.palette.text.primary,
            }}
          >
            {t(Resources.Dashboard.ReportingOverview)}
          </Typography>
          <UnstyledLink to={AppRouting.Reporting.path()}>
            <Typography variant="body2" color="primary.main">
              {t(Resources.Dashboard.ViewFullReport)} →
            </Typography>
          </UnstyledLink>
        </Stack>
        <ReportingKpis />
      </Box>

      <Grid container spacing={3} sx={{ alignItems: "stretch" }}>
        <Grid
          size={{ xs: 12, md: 8 }}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ marginBottom: theme.spacing(Spacing.M) }}
          >
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: 600,
                lineHeight: 1,
                color: theme.palette.text.primary,
              }}
            >
              {t(Resources.Dashboard.PendingWithdrawals)}
            </Typography>
            <UnstyledLink to={AppRouting.WithdrawalApprovals.path()}>
              <Typography variant="body2" color="primary.main">
                {t(Resources.Dashboard.ViewAllWithdrawals)} →
              </Typography>
            </UnstyledLink>
          </Stack>
          <Box sx={{ flex: 1 }}>
            <PendingWithdrawalsTable fillHeight />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <ProjectStatusChart />
        </Grid>
      </Grid>
    </Stack>
  );
};
